module.exports = __webpack_public_path__ + "images/social-icons/twitter-icon.ff9bdb91096480df6dbf.svg";